/**
 * #2190 項目 3 予約の申し込みの鍵。同じ内容の申し込みなら同じ鍵を返す (サーバは同じ鍵なら同じ予約を返す)。
 *
 * 以前は、予約を作った後に決済の準備が失敗すると、送り直しで予約がもう 1 つ作られ、席を二重に押さえた
 * (ログインのし直し・モーダルの開き直しの後も同じ)。鍵はタブの中 (sessionStorage) に置くので、
 * ログインで画面を離れて戻ってきても同じ鍵になる。
 *
 * - 内容 (店・日時・人数・コース・飲み放題・連絡先・要望) が変わったら新しい鍵 (別の申し込み)
 * - 予約が成り立ったら `forgetReservationRequestKey` で捨てる (同じ内容でもう 1 件予約できるように)
 * - sessionStorage が使えなければ毎回新しい鍵 (前と同じ動き)
 */
const STORAGE_KEY = 'yokoso.reservationRequestKey.v1'
/** 仮押さえ (15 分) より長く。過ぎた申し込みはサーバが期限切れにし、同じ鍵でも新しい予約になる */
const TTL_MS = 30 * 60_000

export function reservationRequestKey(content: Record<string, unknown>): string {
  const sig = JSON.stringify(content)
  try {
    const saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null') as
      { sig?: string; key?: string; at?: number } | null
    if (saved?.key && saved.sig === sig && Date.now() - (saved.at ?? 0) < TTL_MS) return saved.key
  } catch { /* 読めなければ新しい鍵 */ }
  const key = crypto.randomUUID()
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ sig, key, at: Date.now() }))
  } catch { /* 保存できなくても、この送信は進める */ }
  return key
}

export function forgetReservationRequestKey(): void {
  try { sessionStorage.removeItem(STORAGE_KEY) } catch { /* noop */ }
}
